export default {
    _targets: null,
    _toggles: null,
    _toggleClass: null,
    _targetClass: null,
    
    init() {
        this._toggles = document.querySelectorAll('[data-toggle]');
        this._targets = document.querySelectorAll('[data-toggle-target]');

        if (!this._toggles.length || !this._targets.length) {
            return;
        }

        // For each button, add event listener
        for (const button of this._toggles) {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                if (button.classList.contains('hamburger--mobile')) {
                    if (button.classList.contains('is-active')) {
                        button.classList.remove('is-active');
                    }
                    else {
                        button.classList.add('is-active');
                    }
                } /* else {*/
             //   } */
                this._toggleClass = button.classList[0] + '--active';
                for (const btn of this._toggles) {
                    btn.classList.remove(this._toggleClass)
                }

                for (const target of this._targets) {
                    const targetClass = target.classList[0] + '--active';
                    if ((target.getAttribute('data-toggle-target') === button.getAttribute('data-toggle')) && (target.getAttribute('data-toggle-group') === button.getAttribute('data-toggle-group'))) {
                        if (target.classList.contains(targetClass)) {
                            target.classList.remove(targetClass);
                        }
                        else {
                            target.classList.add(targetClass);
                            
                            /* spacial case for faq-form - to set the dynamic question value on form */
                            if(targetClass == "faq__feedback--active"){
                                let field = document.getElementById("fields-formie-form-faq-question");
                                let question = button.getAttribute('data-question'); 
                                field.value = question;
                            }
                        }
                    }
                    else {
                        if (target.classList.contains(targetClass)) {
                            target.classList.remove(targetClass);
                        }       
                    }
                }
                
                button.classList.add(this._toggleClass );
            });
        }
    } 
}